import { module } from 'stereomodularjs';
import '@justinribeiro/lite-youtube';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // change the style in the lite-youtube plugin from the shadowroot on the id playButton element
        const style = document.createElement('style');
        style.textContent = `
            #playButton {
                isolation:isolate;
                width:82px;
                height:82px;
                z-index:10;
                border-radius:1000px;
                background-image: none;
                background: none;
                background-color: white;
                color: black;
                transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1), color 0.3s cubic-bezier(0.4, 0, 0.2, 1);

                &:hover {
                    background-color: black;
                    color: white;
                }
            }

            #playButton::before{
                content: "";
                display: block;
                width: 24px;
                height: 24px;
                position: absolute;
                top: 50%;
                left: 50%;
                mask-image: url("data:image/svg+xml,%3Csvg width='20' height='23' viewBox='0 0 20 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.33154 0.483398L19.3862 11.9266L0.94318 22.7327L1.33154 0.483398ZM3.26908 4.07931L3.00503 19.2066L15.5444 11.8596L3.26908 4.07931Z' fill='black'/%3E%3C/svg%3E%0A");
                mask-size: contain;
                mask-position: center;
                mask-repeat: no-repeat;
                background-color: currentColor;
                transform: translate(-50%, -50%);
                z-index: 11;
                border: none !important;
            }

            #frame::before{
                background: rgba(34,35,47,0.25);
                height: 100%;
                pointer-events: none;
            }

            #frame::after{
                content:"";
                display: block;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 8px;
                background: var(--gradient-rainbow);
                pointer-events: none;
                transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            }
            
            #frame.activated::after{
                opacity: 0;
            }
        `;
        this.el.querySelector('lite-youtube').shadowRoot.appendChild(style);
        this.el.querySelector('lite-youtube').setAttribute('aria-label', this.el.querySelector('lite-youtube').getAttribute('title'));
        this.el.querySelector('lite-youtube').removeAttribute('title');

        this.el.addEventListener('click', () => {
            this.el.classList.add('is-active');
        });
    }

    destroy() {
        this.el.removeEventListener('click', () => {
            this.el.classList.add('is-active');
        });
    }
}